<div #disclaimerContainer class="max-w-80 w-fit bg-semiblack text-white rounded-md text-sm p-4"
    [class]="{'hidden': !showElement()}">
    <div class="flex justify-between items-start">

        <p [innerHTML]="disclaimerText()"></p>

        <button class="ml-4 cursor-pointer pointer-events-auto flex-shrink-0" (click)="close()">
            <img src="assets\img\icons\icon-close.svg" alt="" class="w-3 h-3">
        </button>
    </div>
</div>
